module.exports = __webpack_public_path__ + "static/media/bg_minigame_fish_water.e90138ca.png";